// src/api/ProfilePicturesAPI.js
import { api } from "./client";

const BASE = "/api/admin/profile-pictures";

// Local backend storage returns a relative path (/uploads/avatars/...), S3 an absolute URL.
const absoluteUrl = (url) =>
  typeof url === "string" && url.startsWith("/") ? `${api.defaults.baseURL}${url}` : url;

export const ProfilePicturesAPI = {
  /** Neueste Profilbilder zuerst; liefert { items, page, size, totalItems, totalPages }. */
  list: async ({ page = 0, size = 48 } = {}) => {
    const { data } = await api.get(BASE, { params: { page, size } });
    const items = Array.isArray(data?.items)
      ? data.items.map((item) => ({ ...item, avatarUrl: absoluteUrl(item.avatarUrl) }))
      : [];
    return { ...data, items };
  },

  /** Entfernt nur das Bild; der User sieht danach wieder seinen Level-Avatar. */
  removePicture: async (userId) => {
    await api.delete(`${BASE}/${encodeURIComponent(userId)}`);
  },

  /** Löscht den kompletten Account (Keycloak-User, Profil, Freundschaften, Bild). */
  deleteUser: async (userId) => {
    await api.delete(`/api/admin/users/${encodeURIComponent(userId)}`);
  },
};
